import React from 'react';

export default function PageTitleHeader({
  title,
  icon,
  subtitle,
  titleColor = '#1A5A78',
  iconBg = 'linear-gradient(135deg, #0891B2, #155E75)',
  containerStyle = {},
  titleStyle = {},
  subtitleStyle = {},
  showBar = true
}) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 'calc(var(--sp-md2)*1.32075)',
        marginBottom: 0,
        ...containerStyle
      }}>
      {showBar && (
        <div
          style={{
            width: 'calc(var(--fs-xs)*0.5660377)',
            minHeight: subtitle ? 'calc(var(--fs-xl)*2.5)' : 'calc(var(--fs-xl)*1.50943)',
            borderRadius: 'calc(var(--sp-md2)*1.132075)',
            background: 'linear-gradient(180deg, #0E7490 0%, #38BDF8 100%)'
          }}
        />
      )}
      {/* Content */}
      <div>
        <div
          style={{
            fontSize: 'calc(var(--fs-xl)*1.50943)',
            fontWeight: 700,
            color: titleColor,
            lineHeight: 1.1,
            ...titleStyle
          }}>
          {title}
        </div>

        {subtitle ? (
          <div
            style={{
              marginTop: 'calc(var(--sp-xxs)*2)',
              fontSize: 'calc(var(--fs-sm)*1)',
              color: '#64748B',
              ...subtitleStyle
            }}>
            {subtitle}
          </div>
        ) : null}
      </div>
    </div>
  );
}
